<template>
  <div class="" style="min-height:100vh">
    <b-img
      src="http://19441656.s21i.faiusr.com/2/ABUIABACGAAgmbqN6AUomrPwlAEwyA44hAM.jpg"
      fluid
      class="tech-news-banner"
    />
    <div class="container " style="">
      <h2
        class="text-center p-4"
        style="font-size:34px;font-weight:600;padding-bottom:.25rem!important"
      >
        {{ $t("common.tech") }}
      </h2>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: require("../../../static/images/newstechBanner.jpg"),
    };
  },
};
</script>

<style scoped>
.tech-news-banner {
  width: 100%;
}
</style>
